const TEXTS = [
  {
    "text": "Audubon in Indian Dress • From a pencil sketch drawn by himself for Miss Rathbone, 1826. Now in the possession of Mrs. Abraham Dixon (née Rathbone), London, England."
  },
  {
    "text": "INDIAN HATCHET-PIPE.Carried by Audubon during many of his journeys."
  },
  {
    "text": "Victor was born June 12, 1809, at Gwathway's Hotel of the Indian Queen."
  },
  {
    "text": "He had gone with a party of Osage Indians, but his journey back was made alone."
  },
  {
    "text": "I met a party of Osage Indians encamped, and asked in French to stay with them."
  },
  {
    "text": "They understood me, and before long I had my supper of boiled bear's-fat and pecan-nuts, of which I ate heartily, then lay down with my feet to the fire, and slept so soundly that when I awoke my astonishment was great to find all the Indians had gone hunting, and only left two dogs to keep the camp free from wolves."
  },
  {
    "text": "It was during these years, that is from 1811 to 1819, that many months were passed hunting with the Indians, the Osage tribe being the one whose language Audubon spoke."
  },
  {
    "text": "Late in life he wrote: “Of all the Indian tribes I know, the Osage are by far the superior.”"
  },
  {
    "text": "With them he delighted to track the birds and quadrupeds as only an Indian or one of like gifts, can; from them he learned much woodcraft; with them he strengthened his already iron constitution; and in fearlessness, endurance, patience, and marvellously keen vision, no Indian surpassed him."
  },
  {
    "text": "That wonderful vision which surprised even the keen-eyed Indian never failed him."
  },
  {
    "text": "Mr. Rathbone, Sr., asked me much about Indians, and American trees, the latter quite unknown here, and as yet I have seen none larger than the saplings of Louisiana."
  },
  {
    "text": "Judge of my surprise when, during the third course, I saw on the table a dish of Indian corn, purposely for me."
  },
  {
    "text": "The principal conversation about it always turns to Indians and their ways, as if the land produced nothing else."
  },
  {
    "text": "I imitated, at Mrs. Rathbone's request, the Owl's cry, and the Indian yell."
  },
  {
    "text": "I was struck with the resemblance of the women of the lower classes to our Indian squaws."
  },
  {
    "text": "I found him a very polished man, and after some conversation he asked me to write him a paper on the manners and customs of Indians."
  },
  {
    "text": "I was introduced to Judge ——, on his way to court,—a monstrously ugly old man, with a wig that might make a capital bed for an Osage Indian during the whole of a cold winter on the Arkansas River."
  },
  {
    "text": "Vegetation about as forward as at Eastport; saw a Chimney Swallow, heard some Blue Jays, saw some Indians in a bark canoe, passed Cape Porcupine, a high, rounding hill, and Cape George, after which we entered the Gulf of St. Lawrence."
  },
  {
    "text": "Our captain called on a half-breed Indian in the employ of the Northeast Fur and Fish Co., living with his squaw and two daughters."
  },
  {
    "text": "We met here two large boats containing about twenty Montagnais Indians, old and young, men and women."
  },
  {
    "text": "The men were stout and good-looking, spoke tolerable French, the skin redder than any Indians I have ever seen, and more clear; the women appeared cleaner than usual, their hair braided and hanging down, jet black, but short."
  },
  {
    "text": "This evening we have been visiting the Montagnais Indians' camp, half a mile from us, and found them skinning Seals, and preparing the flesh for use."
  },
  {
    "text": "Not a bush is to be met with, and the Indians who now and then go across are obliged to carry their tent poles with them, as well as their canoes; they burn moss for fuel."
  },
  {
    "text": "The Indians brought in no Grouse."
  },
  {
    "text": "We talked of the country where we were, of the beings best fitted to live and prosper here, not only of our species, but of all species, and also of the enormous destruction of everything here, except the rocks; the aborigines themselves melting away before the encroachments of the white man, who looks without pity upon the decrease of the devoted Indian, from whom he rifles home, food, clothing, and life."
  },
  {
    "text": "For as the Deer, the Caribou, and all other game is killed for the dollar which its skin brings in, the Indian must search in vain over the devastated country for that on which he is accustomed to feed, till, worn out by sorrow, despair, and want, he either goes far from his early haunts to others, which in time will be similarly invaded, or he lies on the rocky seashore and dies."
  },
  {
    "text": "We are often told rum kills the Indian; I think not; it is oftener the want of food, the loss of hope as he loses sight of all that was once abundant, before the white man intruded on his land and killed off the wild quadrupeds and birds with which he has fed and clothed himself since his creation. "
  },
  {
    "text": "He will not trade with the Indians, of whom we saw about twenty, of the Montagnais tribes, and employs only white serving-men."
  },
  {
    "text": "He complained of the American fishermen very much, told us they often acted as badly as pirates towards the Indians, the white settlers, and the eggers, all of whom have been more than once obliged to retaliate, when bloody encounters have been the result."
  },
  {
    "text": "Fifteen miles north of this place, he says, begins a lake represented by the Indians as four hundred miles long by one hundred broad."
  },
  {
    "text": "Some signs of cultivation are to be seen across the harbor, and many huts of Mic-Mac Indians adorn the shores."
  },
  {
    "text": "We spoke to some of the native Indians to try to engage them to show us the way to the interior, where we are told the Small, or True Ptarmigan abounds, but they were too lazy even to earn money."
  },
  {
    "text": "Several Indians came on board and promised to go to-morrow after Hares."
  },
  {
    "text": "We have had a beautiful day; this morning some Indians came alongside; they had half a Reindeer or Caribou, and a Hare which I had never seen before."
  },
  {
    "text": "We took the forty-four pounds of fresh meat and gave in exchange twenty-one of pork and thirty-three of ship-biscuit, and paid a quarter of a dollar for the Hare, which plainly shows that these Indians know full well the value of the game which they procure."
  },
  {
    "text": "I spent a portion of the day in adding a plant to my drawing of the Red-necked Diver, after which we all went on shore to the Indians' camp across the bay."
  },
  {
    "text": "The young Indians simply waded out up to their knees, turned the eel grass over, and secured their prey."
  },
  {
    "text": "The Indians roast them in a fire of brushwood, and devour them without salt or any other et ceteras."
  },
  {
    "text": "The young men went off with the Indians this morning, but returned this evening driven back by flies and mosquitoes."
  },
  {
    "text": "I had a visit from an old Frenchman who has resided on this famous island for fifty years; he assured me that no Red Indians were now to be found: the last he heard of were seen twenty-two years ago."
  },
  {
    "text": "These native Indians give no quarter to anybody; usually, after killing their foes, they cut the heads off the latter, and leave the body to the wild beasts of the country."
  },
  {
    "text": "Captain Sire took me in a light wagon to see old Mr. Chouteau one afternoon, and I found the worthy old gentleman so kind and so full of information about the countries of the Indians that I returned to him a few days afterwards, not only for the sake of the pleasure I enjoyed in his conversation, but also with the view to procure, both dead and alive, a species of Pouched Rat (Pseudostoma bursarius) wonderfully abundant in this section of country."
  },
  {
    "text": "The Indians, poor souls, were more quiet, and had already seated or squatted themselves on the highest parts of the steamer, and were tranquil lookers-on."
  },
  {
    "text": "A few miles above New Brunswick we stopped to take in wood, and landed three of our Indians, who, belonging to the Iowa tribe, had to travel up La Grande Rivière."
  },
  {
    "text": "After leaving this place we fairly entered the Indian country on the west side of the river, for the State of Missouri, by the purchase of the Platte River country, continues for about 250 miles further on the east side, where now we see the only settlements."
  },
  {
    "text": "We saw a good number of Indians in the woods and on the banks, gazing at us as we passed; these are, however, partly civilized, and are miserable enough."
  },
  {
    "text": "Here we stopped to put out our Iowa Indians, and also to land the goods we had for Mr. Richardson, the Indian agent."
  },
  {
    "text": "Our Sac Indian chief started at once across the prairie towards the hills, on his way to his wigwam, and we saw Indians on their way towards us, running on foot, and many on horseback, generally riding double on skins or on Spanish saddles."
  },
  {
    "text": "When the freight was taken in we proceeded, and the whole of the Indians followed along the shore at a good round run; those on horseback at times struck into a gallop."
  },
  {
    "text": "He told us we were now in the country of the Fox Indians as well as that of the Iowas, that the number about him is over 1200, and that his district extends about seventy miles up the river. "
  },
  {
    "text": "When we landed during the high wind we saw a fine sugar camp belonging to Indians."
  },
  {
    "text": "This afternoon we reached the famous establishment of Belle Vue where resides the brother of Mr. Sarpy of St. Louis, as well as the Indian Agent, or, as he might be more appropriately called, the Custom House officer."
  },
  {
    "text": "We had a famous pack of rascally Indians awaiting our landing—filthy and half-starved."
  },
  {
    "text": "The store is no great affair, and yet I am told that they drive a good trade with Indians on the Platte River, and others, on this side of the Missouri."
  },
  {
    "text": "Last July the captain sent twenty dragoons and as many Indians on a hunt for Buffaloes."
  },
  {
    "text": "The Sioux Indians are great enemies to the Potowatamies, and very frequently kill several of the latter in their predatory excursions against them."
  },
  {
    "text": "We saw there many Bank Swallows, and afterwards we came in view of the Blackbird Hill, where the famous Indian chief of that name was buried, at his request, on his horse, whilst the animal was alive."
  },
  {
    "text": "We saw this morning eleven Indians of the Omaha tribe."
  },
  {
    "text": "On a sand-bar afterwards we saw three more Indians, also with a canoe frame, but we only interchanged the common yells usual on such occasions."
  },
  {
    "text": "At our last landing for wood-cutting, we also went on shore, but shot nothing, not even took aim at a bird; and there was an Indian with a flint-lock rifle, who came on board and stared about until we left, when he went off with a little tobacco."
  },
  {
    "text": "We have seen a great number of Black-headed Gulls, and some Black Terns, some Indians on the east side of the river, and a Prairie Wolf, dead, hung across a prong of a tree."
  },
  {
    "text": "After a while we reached a spot where we saw ten or more Indians who had a large log cabin, and a field under fence."
  },
  {
    "text": "We took at Mr. Cerré's establishment two engagés and four Sioux Indians."
  },
  {
    "text": "Michaux had brought the Deer—Indian fashion—about two miles."
  },
  {
    "text": "The most extraordinary part of the history of these drowned Buffaloes is, that the different tribes of Indians on the shores, are ever on the lookout for them, and no matter how putrid their flesh may be, provided the hump proves at all fat, they swim to them, drag them on shore, and cut them to pieces; after which they cook and eat this loathsome and abominable flesh, even to the marrow found in the bones."
  },
  {
    "text": "Ah! Mr. Catlin, I am now sorry to see and to read your accounts of the Indians you saw — how very different they must have been from any that I have seen!"
  },
  {
    "text": "The four Indians we have on board are three Puncas and one Sioux; the Puncas were formerly attached to the Omahas; but, having had some difficulties among themselves, they retired further up the river, and assumed this new name."
  },
  {
    "text": "I was introduced to that gentleman and also to Major Dripps, the Indian agent."
  },
  {
    "text": "They departed soon after six o'clock, and proceeded rapidly down-stream in Indian file."
  },
  {
    "text": "I forgot to say yesterday two things which I should have related, one of which is of a dismal and very disagreeable nature, being no less than the account given us of the clerks of the Company having killed one of the chiefs of the Blackfeet tribe of Indians, at the upper settlement of the Company, at the foot of the great falls of the Missouri, and therefore at the base of the Rocky Mountains, and Mr. Laidlaw assured us that it would be extremely dangerous for us to go that far towards these Indians."
  },
  {
    "text": "Three of our Indian rascals left us at our last wooding-ground, and have gone towards their miserable village."
  },
  {
    "text": "This plant is collected in great quantities by the Indians at this season and during the whole summer, and put to dry, which renders it as hard as wood; it is then pounded fine, and makes an excellent kind of mush, upon which the Indians feed greedily."
  },
  {
    "text": "After we had left our first landing-place a few miles, we observed some seven or eight Indians looking at us, and again retiring to the woods, as if to cover themselves; when we came nearly opposite them, however, they all came to the shore, and made signs to induce us to land."
  },
  {
    "text": "Our Sioux Indian helped himself to another, and they all felt chilly and damp."
  },
  {
    "text": "They had been nine days coming 150 miles, detained every day, more or less, by Indians."
  },
  {
    "text": "They were not followed, and we reached the river at a spot which evidently had been previously camped on by Indians; here we made our minds up to stop at once, and arrange for the night, which now promised to be none of the fairest."
  },
  {
    "text": "After a hearty meal we went to sleep, one and all, under the protection of God, and not much afraid of Indians, of whom we have not seen a specimen since we had the pleasure of being fired on by the Santees."
  },
  {
    "text": "We had not proceeded very far when the difficulties of navigation increased so much that we grounded several times, and presently saw a few Indians on the shore; our yawl was out sounding for a passage amid the many sand-bars in view; the Indians fired, not balls, but a salute, to call us ashore. "
  },
  {
    "text": "It is quite surprising that these Indians did not see us last night, for I have no doubt our fire could have been seen up and down the river for nearly twenty miles."
  },
  {
    "text": "The Indians saw nothing of the three men who were sent yesterday to announce our approach to Fort Pierre."
  },
  {
    "text": "Our visiting Indians left us at twelve last night, and I was glad enough to be rid of these beggars by trade."
  },
  {
    "text": "This is what is called the “Station of the Opposition line;” some Indians and a few lodges are on the edge of the prairie."
  },
  {
    "text": "Sundry bales of Buffalo robes were brought on board, and Major Hamilton, who is now acting Indian agent here until the return of Major Crisp, came on board also."
  },
  {
    "text": "Indians were seen on both sides the river, ready to trade both here and at Fort Pierre, where I am told there are five hundred lodges standing. "
  },
  {
    "text": "The Indian dogs which I saw here so very closely resemble wild Wolves, that I feel assured that if I was to meet with one of them in the woods, I should most assuredly kill it as such."
  },
  {
    "text": "I looked at the Indian Dogs again with much attention, and was assured that there is much cross breeding between these Dogs and Wolves, and that all the varieties actually come from the same root."
  },
  {
    "text": "The hides at present are not worth saving, and the Indians as well as the white hunters, when they shoot a Buffalo, tear off the hide, cut out the better portions of the flesh, as well as the tongue, and leave the carcass to the Wolves and Ravens."
  },
  {
    "text": "I was also presented with two pairs of moccasins, an Indian riding-whip, one collar of Grizzly Bear's claws, and two long strings of dried white apples, as well as two Indian dresses."
  },
  {
    "text": "She soled three pairs of moccasins for me, as skilfully as an Indian."
  },
  {
    "text": "We had a rascally Indian on board, who hid himself for the purpose of murdering Mr. Chardon; the latter gave him a thrashing last year for thieving, and Indians never forget such things—he had sworn vengeance, and that was enough."
  },
  {
    "text": "We passed this morning the old Riccaree Village, where General Ashley was so completely beaten as to lose eighteen of his men, with the very weapons and ammunition that he had trafficked with the Indians of that village, against all the remonstrances of his friends and interpreters; yet he said that it proved fortunate for him, as he turned his steps towards some other spot, where he procured one hundred packs of Beaver skins for a mere song."
  },
  {
    "text": "We stopped to take wood at Bowie's settlement, at which place his wife was killed by some of the Riccaree Indians, after some Gros Ventres had assured him that such would be the case if he suffered his wife to go out of the house."
  },
  {
    "text": "The Indians took parts of her hair and went off. She was duly buried; but the Gros Ventres returned some time afterwards, took up the body, and carried off the balance of her hair."
  },
  {
    "text": "I have been told also, that a Buffalo shot by an Indian, in the presence of several whites, exhibited some marks on the inside of the skin that looked like old wounds, and that on close examination they found no less than six balls in its paunch."
  },
  {
    "text": "We have heard some wonderful stories about Indians and white men, none of which I can well depend upon."
  },
  {
    "text": "We saw more Indians than at any 11previous time since leaving St. Louis; and it is possible that there are a hundred huts, made of mud, all looking like so many potato winter-houses in the Eastern States."
  },
  {
    "text": "Seeing a remarkably fine skin of a large Cross Fox which I wished to buy, it was handed over to me. After this, Mr. Chardon asked one of the Indians to take us into the village, and particularly to show us the “Station of the Opposition line;”Medicine Lodge.”"
  },
  {
    "text": "During my survey there sat, crouched down on his haunches, an Indian wrapped in a dirty blanket, with only his filthy head peeping out."
  },
  {
    "text": "Again, at the foot of one of the posts that support the central portion of this great room, lay a parcel that I took for a bundle of Buffalo robes; but it moved presently, and from beneath it half arose the emaciated body of a poor blind Indian, whose skin was quite shrivelled; and our guide made us signs that he was about to die."
  },
  {
    "text": "We observed a considerable difference in the color of these Indians, who, by the way, are almost all Riccarees; many appeared, and in fact are, redder than others; they are lank, rather tall, and very alert, but, as I have said before, all look poor and dirty."
  },
  {
    "text": "We followed the prairie, a very extensive one, to the hills, and there found a deep ravine, sufficiently impregnated with saline matter to answer the purpose of salt water for the Indians to boil their corn and pemmican, clear and clean; but they, as well as the whites at the fort, resort to the muddy Missouri for their drinking water, the only fresh water at hand."
  },
  {
    "text": "Not a drop of spirituous liquor has been brought to this place for the last two years; and there can be no doubt that on this account the Indians have become more peaceable than heretofore, though now and then a white man is murdered, and many horses are stolen."
  },
  {
    "text": "Our boat has been thronged with Indians ever since we have tied to the shore; and it is with considerable difficulty and care that we can stop them from intruding into our rooms when we are there."
  },
  {
    "text": "Our captain tells us that no matter what weather we may have to-morrow, he will start at daylight, even if he can only go across the river, to get rid of these wolfish-looking vagabonds of Indians."
  },
  {
    "text": "Whilst at the fort this afternoon, I was greatly surprised to see a tall, athletic Indian thrashing the dirty rascals about Mr. Chardon's door most severely; but I found on inquiry that he was called 'the soldier,' and that he had authority to do so whenever the Indians intruded or congregated in the manner this canaille had done."
  },
  {
    "text": "Several great warriors have condescended to shake me by the hand; their very touch is disgusting—it will indeed be a deliverance to get rid of all this 'Indian poetry.'"
  },
  {
    "text": "It is now nine o'clock, but before I go to rest I cannot resist giving you a description of the curious exhibition that we have had on board, from a numerous lot of Indians of the first class, say some forty or fifty."
  },
  {
    "text": "Two individuals (Indians) made their appearance highly decorated, with epaulets on the shoulders, red clay on blue uniforms, three cocks' plumes in their head-dress, rich moccasins, leggings, etc."
  },
  {
    "text": "Two of the Indians, who must have been of the highest order, and who distributed the 'rank weed,' were nearly naked; one had on only a breech-clout and one legging, the other was in no better case."
  },
  {
    "text": "Many Indians, squaws as well as men, are bartering and trading, and keep up such a babble that Harris and I find sleep impossible; needless to say, the squaws who are on board are of the lowest grade of morality."
  },
  {
    "text": "Two miles above this, however, we saw an increasing body of Indians, for the prairie was sprinkled with small parties, on horse and on foot."
  },
  {
    "text": "We saw a crippled and evidently tame Wolf, and two Indians, following us on the top of the hills."
  },
  {
    "text": "Our captain told us that on a previous voyage some Indians asked him if, 'when the great Medicine' (meaning the steamer) 'was tired, he gave it whiskey.'"
  },
  {
    "text": "Whilst the butchers were at work, I was highly interested to see one of our Indians cutting out the milk-bag of the cow and eating it, quite fresh and raw, in pieces somewhat larger than a hen's egg."
  },
  {
    "text": "One of the stomachs was partially washed in a bucket of water, and an Indian swallowed a large portion of this."
  },
  {
    "text": "I have been hearing much of the prevalence of scurvy, from living so constantly on dried flesh, also about the small-pox, which destroyed such numbers of the Indians."
  },
  {
    "text": "Indeed it is said that in the various attacks of this scourge 52,000 Indians have perished."
  },
  {
    "text": "We saw on the prairie ahead of us some Indians, and as we neared them, found them to be Assiniboins."
  },
  {
    "text": "We pushed off, and very soon saw more Indians on the shore, also Assiniboins."
  },
  {
    "text": "Mr. Culbertson's mare, which is of the full Blackfoot Indian breed, is about five years old, and could not be bought for four hundred dollars."
  },
  {
    "text": "Two gentlemen arrived this evening from the Crow Indian Nation; they crossed to our side of the river, and were introduced at once."
  },
  {
    "text": "I took a walk with Mr. Culbertson and Mr. Chardon, to look at some old, decaying, and simply constructed coffins, placed on trees about ten feet above ground, for the purpose of finding out in what manner, and when it would be best for us to take away the skulls, some six or seven in number, all Assiniboin Indians."
  },
  {
    "text": "My two companions assured me that they never had walked so far from the fort unarmed as on this occasion, and said that even a single Indian with a gun and a bow might have attacked us; but if several were together, they would pay no attention to us, as that might be construed to mean war."
  },
  {
    "text": "To fill the time on this dreary day, I asked Mr. Chardon to come up to our room and give us an account of the small-pox among the Indians, especially among the Mandans and Riccarees, and he related as follows: Early in the month of July, 1837, the steamer 'Assiniboin' arrived at Fort Clark with many cases of small-pox on board."
  },
  {
    "text": "An Indian stole the blanket of one of the steamboat's watchmen (who lay at the point of death, if not already dead), wrapped himself in it, and carried it off, unaware of the disease that was to cost him his life, and that of many of his tribe—thousands, indeed."
  },
  {
    "text": " Mr. Chardon sent the man back again, and told them their crop of corn was nothing compared to their lives; but Indians are Indians, and, in spite of all entreaties, they moved en masse, to confront the awful catastrophe that was about to follow."
  },
  {
    "text": "Again and again it was explained to them that this was not the case, but all to no purpose; the small-pox had taken such a hold upon the poor Indians, and in such malignant form, that they died oftentimes within the rising and setting of a day's sun."
  },
  {
    "text": "About this time Mr. Chardon was informed that one of the young Mandan chiefs was bent on shooting him, believing he had brought the pestilence upon the Indians."
  },
  {
    "text": "The Indians, who were quite numerous, clustered about him, and asked him what the bird came to him for?"
  },
  {
    "text": "Little, however, could be done; the small-pox continued its fearful ravages, and the Indians grew fewer and fewer day by day."
  },
  {
    "text": "For a long time the Riccarees did not suffer; the Mandans became more and more astounded at this, and became exasperated against both whites and Indians."
  },
  {
    "text": "One young warrior sent his wife to dig his grave; and she went, of course, for no Indian woman dares disobey her lord. "
  },
  {
    "text": "The exposure and exertion brought on great pains, and one of the men from the fort went to him with something that gave him temporary relief; before he died, he acknowledged his error in trying to create trouble between the whites and Indians, and it was his wish to be buried in front of the gate of the fort, with all his trophies around and above his body; the promise was given him that this should be done, and he died in the belief that the white man, as he trod on his grave, would see that he was humbled before him, and would forgive him."
  },
  {
    "text": "Another story was of an extremely handsome and powerful Indian who lost an only son, a beautiful boy, upon whom all his hopes and affections were placed."
  },
  {
    "text": "The Indians, with few exceptions, died, and three of the whites."
  },
  {
    "text": "The latter had no food in the way of bread, flour, sugar, or coffee, and they had to go stealthily by night to steal small pumpkins, about the size of a man's fist, to subsist upon—and this amid a large number of wild, raving, mad Indians, who swore revenge against them all the while."
  },
  {
    "text": "This is a mere sketch of the terrible scourge which virtually annihilated two powerful tribes of Indians, and of the trials of the traders attached to the Fur Companies on these wild prairies, and I can tell you of many more equally strange."
  },
  {
    "text": "The mortality, as taken down by Major Mitchell, was estimated by that gentleman at 150,000 Indians, including those from the tribes of the Riccarees, Mandans, Sioux, and Blackfeet."
  },
  {
    "text": "He concluded by assuring us all that the small-pox had never been known in the civilized world, as it had been among the poor Mandans and other Indians."
  },
  {
    "text": "As I was walking over the prairie, I found an Indian's skull (an Assiniboin) and put it in my game pouch."
  },
  {
    "text": "Mr. Kipp presented me with a complete dress of a Blackfoot warrior, ornamented with many tufts of Indian hair from scalps, and also with a saddle."
  },
  {
    "text": "We reached Fort Mortimer in due time; passed first between several sulky, half-starved looking Indians, and came to the gate, where we were received by the 'bourgeois,' a young man by the name of Collins, from Hopkinsville, Ky."
  },
  {
    "text": "Harris gave the whip to Peter, and off we went, evidently gaining rapidly on the beast, when it saw an Indian in its road; taking fright, it dashed to one side, and was soon lost in a ravine."
  },
  {
    "text": "Some person outside of the fort threw a large stone at an Indian woman, and her husband fired in the dark, but no one could be found on searching."
  },
  {
    "text": "We procured a young Red-shafted Woodpecker, killed by an Indian boy with a bow and arrow. "
  },
  {
    "text": "I was told a curious anecdote connected with a Grizzly Bear, that I will write down; it is as follows: One of the engagés of the Company was forced to run away, having killed an Indian woman, and made his way to the Crow Fort, three hundred miles up the Yellowstone River. When he arrived there he was in sad plight, having his own squaw and one or two children along, who had all suffered greatly with hunger, thirst, and exposure. They were received at the fort, but in a short time, less than a week afterwards, he again ran off with his family, and on foot. The discovery was soon made, and two men were sent after him; but he eluded their vigilance by keeping close in ravines, etc. The men returned, and two others with an Indian were despatched on a second search, and after much travel saw the man and his family on an island, where he had taken refuge from his pursuers. The Buffalo-hide canoe in which he had attempted to cross the river was upset, and it was with difficulty that he saved his wife and children. They were now unable to escape, and when talking as to the best way to secure their return to the fort, the soldiers saw him walk to the body of a dead Buffalo lying on the shore of the island, with the evident intention of procuring some of it for food. As he stooped to cut off a portion, to his utter horror he saw a small Grizzly Bear crawl out from the carcass. It attacked him fiercely, and so suddenly that he was unable to defend himself; the Bear lacerated his face, arms, and the upper part of his body in a frightful manner, and would have killed him, had not the Indian raised his gun and fired at the Bear, wounding him severely, while a second shot killed him. The engagé was too much hurt to make further effort to escape, and one of the Company's boats passing soon after, he and his family were taken back to the fort, where he was kept to await his trial."
  },
  {
    "text": "He crossed the river and found a horse belonging to the Indians, stole it, and reached the fort at last."
  },
  {
    "text": "Whilst Harris and Mr. Culbertson went off to see Mr. Collins, Mr. Denig and I walked off with a bag and instruments, to take off the head of a three-years-dead Indian chief, called the White Cow."
  },
  {
    "text": "Whilst we were sitting at the back gate of the fort, we saw a parcel of Indians coming towards the place, yelling and singing what Mr. Culbertson told me was the song of the scalp dance; we saw through the telescope that they were fourteen in number, with their faces painted black, and that it was a detachment of a war party."
  },
  {
    "text": "When within a hundred yards they all stopped, as if awaiting an invitation; we did not hurry as to this, and they seated themselves on the ground and looked at us, while Mr. Culbertson sent Mr. Denig to ask them to come in by the front gate of the fort, and put them in the Indian house, a sort of camp for the fellows."
  },
  {
    "text": "The Assiniboins took several guns and seven horses, and the scalp of the dead Indian."
  },
  {
    "text": "A rascally Indian had stolen his gun and Bighorn bow; the gun he said he could easily replace, but the loss of the bow he regretted exceedingly."
  },
  {
    "text": "This morning the dirty Indians, who could have washed had they so minded, were beating the tambour and singing their miserable scalp song, until Mr. Culbertson ordered the drum taken away, and gave them more tobacco and some vermilion to bedaub their faces."
  },
  {
    "text": "I think the Indians hereabouts poor swimmers; they beat the water with their arms, attempting to 'nage à la brasse;' but, alas! it is too bad to mention."
  },
  {
    "text": "Mr. Culbertson told me this morning that last spring early, during a snow-storm, he and Mr. Larpenteur were out in an Indian lodge close by the fort, when they heard the mares which had young colts making much noise; and that on going out they saw a single Wolf that had thrown down one of the colts, and was about doing the same with another."
  },
  {
    "text": "When I came down this morning early, I was delighted to see the dirty and rascally Indians walking off to their lodge on the other side of the hills, and before many days they will be at their camp enjoying their merriment (rough and senseless as it seems to me), yelling out their scalp song, and dancing."
  },
  {
    "text": "Indians are not equal to the whites in the art of dyeing Porcupine quills; their ingredients are altogether too simple and natural to equal the knowledge of chemicals."
  },
  {
    "text": "I drew at Mr. Culbertson's portrait till he was tired enough; his wife—a pure Indian—is much interested in my work."
  },
  {
    "text": "Mr. Culbertson gave me a grand pair of leather breeches and a very handsome knife-case, all manufactured by the Blackfeet Indians."
  },
  {
    "text": "We saw ten Wolves this morning. After dinner we had a curious sight. Squires put on my Indian dress."
  },
  {
    "text": "Squires and Owen were painted in an awful manner by Mrs. Culbertson, the Ladies had their hair loose, and flying in the breeze, and then all mounted on horses with Indian saddles and trappings. Mrs. Culbertson and her maid rode astride like men, and all rode a furious race, under whip the whole way, for more than one mile on the prairie; and how amazed would have been any European lady, or some of our modern belles who boast their equestrian skill, at seeing the magnificent riding of this Indian princess—for that is Mrs. Culbertson's rank—and her servant. Mr. Culbertson rode with them, the horses running as if wild, with these extraordinary Indian riders, Mrs. Culbertson's magnificent black hair floating like a banner behind her."
  },
  {
    "text": "Mr. Culbertson presented Harris with a superb dress of the Blackfoot Indians, and also with a Buffalo bull's head, for which Harris had in turn presented him with a gun-barrel of the short kind, and well fitted to shoot Buffaloes."
  },
  {
    "text": "A man was sent to assist in the skinning who had been preparing the Wolf which was now cooking, as we had expected to dine upon its flesh; but when Mr. Culbertson returned, covered with blood and looking like a wild Indian, it was decided to throw it away; so I cut out the liver, and old Provost and I went fishing and caught eighteen catfish."
  },
  {
    "text": "An Indian arrived with a stolen squaw, both Assiniboins; and I am told such things are of frequent occurrence among these sons of nature."
  },
  {
    "text": "Immediately after breakfast Provost and Lafleur went across the river in search of Antelopes, and we remained looking at the Indians, all Assiniboins, and very dirty. When and where Mr. Catlin saw these Indians as he has represented them, dressed in magnificent attire, with all sorts of extravagant accoutrements, is more than I can divine, or Mr. Culbertson tell me."
  },
  {
    "text": "The Indians are, as usual, shut out of the fort, all the horses, young Buffaloes, etc., shut in; and much refreshed by my bath, I say God bless you, and good-night."
  },
  {
    "text": "About one o'clock Harris was called to see one of the Indians, who was bleeding at the nose profusely, and I too went to see the poor devil."
  },
  {
    "text": "When the sun had fairly risen, some one came and told me the hill-tops were covered with Indians, probably Blackfeet."
  },
  {
    "text": "If our Congress will not allow our traders to sell whiskey or rum to the Indians, why should not the British follow the same rule?"
  },
  {
    "text": "After this, seeing the Assiniboins loitering about the fort, we had some tobacco put up as a target, and many arrows were sent to enter the prize, but I never saw Indians—usually so skilful with their bows—shoot worse in my life."
  },
  {
    "text": "They have promised to go to-morrow, but, alas! the half-breeds are so uncertain I cannot tell whether they will move a step or not. Mrs. Culbertson, who has great pride in her pure Indian blood, told me with scorn that 'all such no-color fellows are lazy.'"
  },
  {
    "text": "On our return Mrs. Culbertson was good enough to give me six young Mallards, which she had caught by swimming after them in the Missouri; she is a most expert and graceful swimmer, besides being capable of remaining under water a long time; all the Blackfoot Indians excel in swimming and take great pride in the accomplishment."
  },
  {
    "text": "The fellow had a spear made of a cut-and-thrust sword, planted in a good stick covered with red cloth, and this he never put down at any time; but no more, indeed, do any Indians, who carry all their goods and chattels forever about their persons."
  },
  {
    "text": "Now who will tell me that no animal can compete with this Fox in speed, when Harris, mounted on an Indian horse, overtook it in a few minutes?"
  },
  {
    "text": "I took my gun and walked off ahead, and on ascending the first hill saw an Antelope, which, at first sight, I thought was an Indian."
  },
  {
    "text": "The poor wretched Indian whom Harris had worked over, died yesterday morning, and was buried at once."
  },
  {
    "text": "I was told this afternoon that at Mouse River, about two hundred miles north of this, there are eight hundred carts in one gang, and four hundred in another, with an adequate number of half-breeds and Indians, killing Buffalo and drying their meat for winter provisions, and that the animals are there in millions."
  },
  {
    "text": "We saw the horses, and the cloud of dust that they raised on the prairies, and presently, when the Guards reached the gates, they told us that they had seen a party of Indians, which occasioned their hurried return."
  },
  {
    "text": "It is now more than one hour since I wrote this, and the Indians are now in sight, and we think they were frightened by three or four squaws who had left the fort in search of 'pommes blanches.' Sprague has collected a few seeds, but I intend to have some time devoted to this purpose before we leave on our passage downwards. This evening five Indians arrived, among whom is the brother of the man who died a few days ago; he brought a horse, and an Elk skin, which I bought, and he now considers himself a rich man."
  },
  {
    "text": "When Assiniboin Indians lose a relative by death, they go and cry under the box which contains the body, which is placed in a tree, cut their legs and different parts of the body, and moan miserably for hours at a time. This performance has been gone through with by the brother of the Indian who died here."
  },
  {
    "text": "The brother of the dead Indian, who gashed his legs fearfully this morning, went off with his wife and children and six others, who had come here to beg."
  },
  {
    "text": "We sent off four Indians after Rabbits, but as we foolishly gave them powder and shot, they returned without any very soon, having, of course, hidden the ammunition."
  },
  {
    "text": "We had an arrival of six Chippeway Indians, and afterwards about a dozen Assiniboins."
  },
  {
    "text": "On the arrival of the Assiniboins, who were headed by an old man, one of the Chippeways discovered a horse, which he at once not only claimed, but tied; he threw down his new blanket on the ground, and was leading off the horse, when the other Indian caught hold of it, and said that he had fairly bought it, etc. The Chippeway now gave him his gun, powder, and ball, as well as his looking-glass, the most prized of all his possessions, and the Assiniboin, now apparently satisfied, gave up the horse, which was led away by the new (or old) owner."
  },
  {
    "text": "From what had happened, we anticipated a row among the Indians, but all seemed quiet."
  },
  {
    "text": "This morning we had another visitation of Indians, seven in number; they were very dirty, wrapped in disgusting Buffalo robes, and were not allowed inside the inner gate, on account of their filthy condition."
  },
  {
    "text": "This afternoon we had an arrival of Indians, the same who were here about two weeks ago."
  },
  {
    "text": "Very young Buffaloes have been caught in the same way, by the same gentleman, assisted by Le Brun and four Indians, and thirteen of these he took down the river, when they became somewhat tamed."
  },
  {
    "text": "They left at seven, and the Indians were curious to know where they were bound, and looked at them with more interest than we all liked."
  },
  {
    "text": "Our Indians took two bodies and burned them, after scalping them. The Indians who were with us in this skirmish deserve but little credit for their bravery, for in every close engagement the whites, who were comparatively few, always were in advance of them."
  },
  {
    "text": "Had it not been for the assistance we gave the Piegans they would have been cut off, for I never saw Indians behave more bravely than the enemy this day; and had they been well supplied with powder and ball they would have done much more execution."
  },
  {
    "text": "And on our side had we been positive they were enemies, even after they had surprised us in the manner they did, we could have killed many of them at first, but thinking that they were a band of Indians coming with this ceremony to trade (which is not uncommon) we did not fire upon them till the balls and arrows came whistling about our heads; then only was the word given, 'Fire!' Had they been bold enough at the onset to have rushed into the fort, we could have done nothing but suffer death under their tomahawks."
  },
  {
    "text": "Carrière was a man about seventy years old, and had passed most of his life in the Indian country, in this dangerous occupation of trapping."
  },
  {
    "text": "We have nine Indians, all Assiniboins, among whom five are chiefs. These nine Indians fed for three days on the flesh of only a single Swan; they saw no Buffaloes, though they report large herds about their village, fully two hundred miles from here."
  },
  {
    "text": "The nine Indians, having received their presents, went off with apparent reluctance, for when you begin to give them, the more they seem to demand."
  },
  {
    "text": "The thing that troubles them most is crossing rivers on the ice; their hoofs slip from side to side, they become frightened, and stretch their four legs apart to support the body, and in such situations the Indians and white hunters easily approach, and stab them to the heart, or cut the hamstrings, when they become an easy prey."
  },
  {
    "text": "Indians of different tribes hunt the Buffalo in different ways; some hunt on horseback, and use arrows altogether; they are rarely expert in reloading the gun in the close race."
  },
  {
    "text": "The poor Buffaloes, usually headed by a large bull, proceed, leap down the bank in haste and confusion, the Indians all yelling and pursuing till every bull, cow, and calf is impounded."
  },
  {
    "text": "The same thing sometimes takes place in the pen, for so full does this become occasionally that the animals touch each other, and as they cannot move, the very weight against the fence of the pen is quite enough to break it through; the smallest aperture is sufficient, for in a few minutes it becomes wide, and all the beasts are seen scampering over the prairies, leaving the poor Indians starving and discomfited."
  },
  {
    "text": "Fresh signs of Indians, burning wood embers, etc. I knocked a cow down with two balls, and Mr. Culbertson killed her."
  },
  {
    "text": "Then the Wolves howled so curiously that it was supposed they were Indian dogs."
  },
  {
    "text": "Reached the Mandan village; hundreds of Indians swam to us with handkerchiefs tied on their heads like turbans."
  },
  {
    "text": "We were stopped by the wind for four hours, but started again at three; passed the Butte Quarré at a quarter past five, followed now by the canoe, as the two fellows are afraid of Indians, and want to come on board our boat; we have not room for them, but will let them travel with us."
  },
  {
    "text": "Saw the prairie on fire, and signs of Indians on both sides."
  },
  {
    "text": "Two rows of horses with Indians dressed in full war rig are rushing onwards; small black marks everywhere represent the horse tracks; round green marks are shields thrown away by the enemy in their flight, and red spots on the horses, like wafers, denote wounds."
  },
  {
    "text": "Fresh signs of both Indians and Buffaloes, but nothing killed."
  },
  {
    "text": "Provost saw fresh signs of Indians, and we were told that there were a few lodges at the bottom of the Bend, about two miles below us."
  },
  {
    "text": "Signs of Indians."
  },
  {
    "text": "Fresh signs of Indians."
  },
  {
    "text": "Signs of Indians, Elks, and Deer."
  },
  {
    "text": "Abundance of Indians, of four different nations."
  },
  {
    "text": "Indian war-whoops were heard by him and his men whilst embarking this morning after we left."
  },
  {
    "text": "Started and ran twelve miles to a good camp on the Indian side."
  },
  {
    "text": "Extracts from Mr. Culbertson's Journal, kept at Fort McKenzie, Blackfeet Indian Country in 1834."
  },
  {
    "text": "Blood Indians started this morning to go to war against the Crows."
  },
  {
    "text": "They then crossed the river and came on the high bank opposite to the fort, and fired upon us, and while some of them were yet crossing the river I let loose a cannon ball among them, which, if it did no harm, made them move at a quick pace, and after a while they all went off, leaving us without food of any sort; but fortunately on Monday the 30th, a party of Blood Indians came in from the Crows with fifteen horses and considerable meat."
  },
  {
    "text": "From these extracts the nature of the Indians of these regions may be exemplified a thousand times better, because true, than by all the trashy stuff written and published by Mr. Catlin."
  },
  {
    "text": "In the interior of the northeast bastion are placed opposite their port-holes one three-pounder iron cannon and one brass swivel, both mounted, and usually kept loaded, together with a dozen muskets in case of a sudden attack from the Indians."
  },
  {
    "text": "Here from the pencils of Mr. Audubon and Mr. Sprague emanate the splendid paintings and drawings of animals and plants, which are the admiration of all; and the Indians regard them as marvellous, and almost to be worshipped. In the room next to this is always kept a selection of saddlery and harness, in readiness for rides of pleasure, or for those rendered necessary for the protection of the horses which are kept on the prairie, and which suffer from frequent depredations on the part of the Indians, which it is the duty of the men at the fort to ward off as far as possible."
  },
  {
    "text": "The next apartment is the tailor's shop, so placed as to be out of the way of the Indian visitors as much as possible, who, were it at all easy of access, would steal some of the goods which it is necessary to have always on hand."
  },
  {
    "text": "On the front side, and west of the gate, is a house 50 by 21 feet, which, being divided into two parts, one half opening into the fort, is used as a blacksmith's, gunsmith's, and tinner's shop; the other part is used as a reception-room for Indians, and opens into the passage, which is made by the double gate."
  },
  {
    "text": "There are two large outside gates to the fort, one each in the middle of the front and rear, and upon the top of the front one is a painting of a treaty of peace between the Indians and whites executed by J. B. Moncrévier, Esq."
  },
  {
    "text": "These gates are 12 ft. wide, and 14 ft. high. At the front there is an inside gate of the same size at the inner end of the Indian reception room, which shuts a passage from the outside gate of 32 ft. in length, and the same width as the gate; the passage is formed of pickets."
  },
  {
    "text": "The outside gate can be left open, and the inside one closed, which permits the Indians to enter the reception room without their having any communication with the fort."
  },
  {
    "text": "Into this room are brought all trading and war parties, until such time as their business is ascertained; there is also behind this room a trade shop, and leading into it a window through which the Indians usually trade, being secure from rain or accident; there is also another window through the pickets to the outside of the fort, which is used in trading when the Indians are troublesome, or too numerous."
  },
  {
    "text": "It is indeed pleasant to know that the enterprising men who commenced, and have continued with untiring perseverance, the enlargement of the Indian trade, and labored hard for the subordination, if not civilization, of the Indians, should occasionally sit down under their own vine and fig-tree, and enjoy at least the semblance of living like their more quiet, though not more useful brothers in the United States."
  },
  {
    "text": "The American Fur Company, whose untiring perseverance and enterprise have excited the wonder and admiration of many people, both in this and other countries, and who have already acquired a well-earned fame for their labors among the aborigines of this wilderness, and who are now an example of the energy of the American people, had, until the year 1832, no stations among the Blackfeet, Piegans, Blood Indians, or Gros Ventres de Prairie, these tribes being so hostile and bloodthirsty as to make the trading, or the erecting of a fort among them too dangerous to be attempted."
  },
  {
    "text": "The fort was begun in 1832, under the superintendence of David D. Mitchell, then one of the clerks of the Company, now U.S. Superintendent of Indian Affairs."
  },
  {
    "text": "They were surrounded by dangers of all kinds, but more especially from the tribes of Indians before mentioned."
  },
  {
    "text": "From this bank little or no danger is apprehended, as the river is about one hundred yards wide, and a ball fired by the Indians from this height, and at this distance, with the weapons that they have, would be incapable of doing any execution."
  },
  {
    "text": "In each bastion is a cannon, loaded muskets, cartridges, balls, and every requisite necessary to prevent and repel any attack that may take place, and which is hourly expected, from the surrounding tribes of Indians."
  },
  {
    "text": "In this room all parties are received by the interpreter, who is always ready to smoke and talk with the Indians."
  },
  {
    "text": "Opposite the room last described is a similar one 20 by 15 ft., in which the Indians bring their robes to trade."
  },
  {
    "text": "Next this is a trade store, where are kept goods, trinkets, etc., to be traded with the Indians."
  },
  {
    "text": "The trading is done through a window or wicket two feet square, and a foot thick, strongly hinged to the picket; this opening is at the command of the trader, who can open or close it, as the Indians may appear friendly or otherwise, thereby completely cutting off, if necessary, all communication between the Indians and the trade store; and it is through this opening only that trade is carried on."
  },
  {
    "text": "Next this is a room twenty-four feet square, where all goods obtained from the Indians are placed as soon as the trade is finished; and adjoining the trade shop is a room, between it and the pickets, about ten feet square, with a window and door opening into the trade shop, with a chimney, fireplace, and stove used only for warming the trader when off duty, or when awaiting the arrival of Indians."
  },
  {
    "text": "Within a few feet of this, and northeast, is the meat house, twenty-four feet square, in which all meat traded from the Indians is kept till needed for use."
  },
  {
    "text": "The sun had assumed the rich and glowing hue which at that season produces the singular phenomenon called there the 'Indian Summer.'"
  },
  {
    "text": "Several of these happy days passed, and we neared our home, when, one evening, not far from Pigeon Creek (a small stream which runs into the Ohio from the State of Indiana), a loud and strange noise was heard, so like the yells of Indian warfare, that we pulled at our oars, and made for the opposite side as fast and as quietly a possible."
  },
  {
    "text": "Not a single steamer had as yet ever gone down the Ohio; now and then, it is true, a barge or a keel-boat was propelled by poles and oars, but the nature of the river is such at that place, that these boats when ascending were obliged to keep near the Indiana shore, until above the landing of the village (below which I always fixed my lines), when they pulled across the stream."
  },
  {
    "text": "I inquired what might be the value of such an animal among the Osage Indians, and was answered that, the horse being only four years old, he had given for him, with the tree and the buffalo-tug fastened to his head, articles equivalent to about thirty-five dollars."
  },
  {
    "text": "After a while we were joined by many Indians, the observation of whose manners afforded us much amusement."
  },
  {
    "text": "The track which I followed was only an old Indian trace, and as darkness overshadowed the prairie I felt some desire to reach at least a copse, in which I might lie down to rest."
  },
  {
    "text": "I did so, and almost at the same instant, a firelight attracting my eye, I moved towards it, full of confidence that it proceeded from the camp of some wandering Indians."
  },
  {
    "text": "The next object that attracted my notice was a finely formed young Indian, resting his head between his hands, with his elbows on his knees. A long bow rested against the log wall near him, while a quantity of arrows and two or three Raccoon skins lay at his feet. He moved not; he apparently breathed not. Accustomed to the habits of Indians, and knowing that they pay little attention to the approach of civilized strangers (a circumstance which in some countries is considered as evincing the apathy of their character), I addressed him in French, a language not infrequently partially known to the people in that neighborhood. He raised his head, pointed to one of his eyes with his finger, and gave me a significant glance with the other. His face was covered with blood. The fact was that an hour before this, as he was in the act of discharging an arrow at a Raccoon in the top of a tree, the arrow had split upon the cord, and sprung back with such violence into his right eye as to destroy it forever."
  },
  {
    "text": "The Indian rose from his seat, as if in extreme suffering."
  },
  {
    "text": "Observing me and the wounded Indian, they asked who I was, and why the devil that rascal (meaning the Indian, who, they knew, understood not a word of English) was in the house."
  },
  {
    "text": "The Indian exchanged a last glance with me."
  },
  {
    "text": "The infernal hag was advancing slowly, probably contemplating the best way of despatching me, whilst her sons should be engaged with the Indian."
  },
  {
    "text": "The Indian fairly danced with joy, and gave us to understand that, as he could not sleep for pain, he would watch over us."
  },
  {
    "text": "We marched them into the woods off the road, and having used them as Regulators were wont to use such delinquents, we set fire to the cabin, gave all the skins and implements to the young Indian warrior, and proceeded, well pleased, towards the settlements."
  },
  {
    "text": "The Indians outwitted me one dark night, and I was as unexpectedly as suddenly made a prisoner by them."
  },
  {
    "text": "You are aware, I dare say, that to act in this manner was the best policy, as you understand that, by so doing, I proved to the Indians at once that I was born and bred as fearless of death as any of themselves."
  },
  {
    "text": "The Indians all jumped on their feet."
  },
  {
    "text": "I rose on my feet, stretched my stiffened sinews, snatched up my rifle, and, for once in my life, spared that of Indians."
  },
  {
    "text": "With what pleasure did I see them becoming more and more drunk, until the liquor took such hold of them that it was quite impossible for these women to be of any service. They tumbled down, rolled about, and began to snore: when I, having no other chance of freeing myself from the cords that fastened me, rolled over and over towards the fire, and, after a short time, burned them asunder. I rose on my feet, stretched my stiffened sinews, snatched up my rifle, and, for once in my life, spared that of Indians. I now recollect how desirous I once or twice felt to lay open the skulls of the wretches with my tomahawk; but when I again thought upon killing beings unprepared and unable to defend themselves, it looked like murder without need, and I gave up the idea."
  },
  {
    "text": "I soon reached the river, soon crossed it, and threw myself deep into the cane-brakes, imitating the tracks of an Indian with my feet, so that no chance might be left for those from whom I had escaped to overtake me."
  },
  {
    "text": "After some conversation, the affair with the Indians came to my recollection."
  },
  {
    "text": "On approaching the place, I felt as if the Indians were there still, and as if I was still a prisoner among them."
  },
  {
    "text": "Why, at the time when I was caught by the Indians, you would not have walked out in any direction for more than a mile without shooting a buck or a Bear."
  },
  {
    "text": "Game is abundant, and the free Indians were wont in those days to furnish the markets with ample supplies of venison and Wild Turkey."
  },
  {
    "text": "He was also well versed in the Indian languages, spoke French with the greatest purity, and was a religious poet. Many a pleasant hour have I spent in his company; but alas! he has gone the way of all the earth!"
  },
  {
    "text": "I saw that he was a perfect Indian in his knowledge of the woods, for he kept a direct course as precisely as any 'Red-skin' I ever travelled with. All of a sudden he emitted a loud shriek, not unlike that of an Owl, which so surprised me, that I once more instantly levelled my gun. 'No harm, master, I only give notice to my wife and children I am coming.'"
  },
  {
    "text": "We walked in Indian file along the narrow track cut through the canes, passed a wood-yard, and entered the burnt forest, in which we met with so many logs and briers that we judged it better to make for the river, the course of which we followed over a bed of pebbles, my son sometimes ahead, and again falling back, until we reached America, a village having a fine situation, but with a shallow approach to the shore."
  },
  {
    "text": "I was in fact covered just like one of the poorer class of Indians, and was rendered even more disagreeable to the eye of civilized man by not having, like them, plucked my beard, or trimmed my hair in any way."
  },
  {
    "text": "Had I taken a view, I might as well have given you what might be termed a regular account of the form, the height, the tremendous roar of these Falls; might have spoken of people perilling their lives by going between the rock and the sheet of water, calculated the density of the atmosphere in that strange position, related wondrous tales of Indians and their canoes having been precipitated the whole depth—might have told of the narrow, rapid, and rockbound river that leads the waters of the Erie into those of Ontario, remarking en passant the Devil's Hole and sundry other places or objects."
  },
  {
    "text": "Many believe that the Indians did it, either to be the better able to kill the game, or to punish their enemies the Pale-faces. "
  },
  {
    "text": "As to shooting, I have often doubted whether he or Mr. Egan, the worthy pilot of Indian Isle, was best; and rarely indeed have I seen either of them miss a shot."
  },
  {
    "text": "We were mounted on horses of the Indian breed, remarkable for their activity and strength, and were provided with guns and some provisions."
  },
  {
    "text": "The sand seemed to be all sand and nothing but sand, and the palmettoes at times so covered the narrow Indian trail which we followed, that it required all the instinct or sagacity of ourselves and our horses to keep it."
  },
  {
    "text": "Our Indian horses seemed to participate in our joy, and trotted at a smart rate towards the principal building, at the door of which we leaped from our saddles, just as the sun was withdrawing his ruddy light."
  },
  {
    "text": "Pirates or hostile Indians, I was persuaded, had perpetrated the foul deed, and my alarm naturally increased; my heart fluttered, stopped, and heaved with unusual tremors, and I looked towards the setting sun in consternation and despair."
  },
  {
    "text": "On the 12th day of September, while lying in harbor at Indian Key, we were joined by five wrecking vessels."
  },
  {
    "text": "An Indian, who had been picked up somewhere along the coast by a Wrecker, and who was employed as a hunter, was sent ashore in search of venison."
  },
  {
    "text": "After a while the 'Spark' again displayed her sails, and as she silently glided along, we spied a Seminole Indian approaching us in his canoe. The poor, dejected son of the woods, endowed with talents of the highest order, although rarely acknowledged by the proud usurpers of his native soil, has spent the night in fishing, and the morning in procuring the superb feathered game of the swampy thickets; and with both he comes to offer them for our acceptance. Alas! thou fallen one, descendant of an ancient line of freeborn hunters, would that I could restore to thee thy birthright, thy natural independence, the generous feelings that were once fostered in thy brave bosom. But the irrevocable deed is done, and I can merely admire the perfect symmetry of his frame, as he dexterously throws on our deck the Trout and Turkeys which he has captured. He receives a recompense, and without smile or bow, or acknowledgment of any kind, off he starts with the speed of an arrow from his own bow."
  },
  {
    "text": "The country was as level as a floor; our path, although narrow, was well-beaten, having been used by the Seminole Indians for ages, and the weather was calm and beautiful."
  },
  {
    "text": "As the 'Marion' neared the Inlet called 'Indian Key,' which is situated on the eastern coast of the peninsula of Florida, my heart swelled with uncontrollable delight."
  },
  {
    "text": "We now landed, took in the rest of our party, and returned to Indian Key, where we arrived three hours before sunset."
  },
  {
    "text": "Having filled our cask from a fine well, long since dug in the sand of Cape Sable, either by Seminole Indians or pirates, no matter which, we left Sandy Isle about full tide, and proceeded homeward, giving a call here and there at different Keys, with the view of procuring rare birds, and also their nests and eggs."
  },
  {
    "text": "The deputy-collector of Indian Isle gave me the use of his pilot for a few weeks, and I was the more gratified by this, that besides knowing him to be a good man, and a perfect sailor, I was now convinced that he possessed a great knowledge of the habits of birds, and could without loss of time lead me to their haunts."
  },
  {
    "text": "This species is therefore considered as the least valuable, and, indeed, is seldom eaten, unless by the Indians, who, ever alert when the Turtle season commences, first carry off the eggs, and afterwards catch the Turtles themselves."
  },
  {
    "text": "The Green Turtle resorts either to the shores of the Main, between Cape Sable and Cape Florida, or enters Indian, Halifax, and other large rivers or inlets, from which it makes its retreat as speedily as possible, and betakes itself to the open sea."
  },
  {
    "text": "Great numbers, however, are killed by the turtlers and Indians, as well as by various species of carnivorous animals, as Cougars, Lynxes, Bears, and Wolves."
  },
  {
    "text": "Others harpoon them in the usual manner; but in my estimation no method is equal to that employed by Mr. Egan, the pilot of Indian Isle."
  },
  {
    "text": "Sambo, however, alert as an Indian chief, leaped on the naked back of one, and showing his teeth, laughed at his master's curses."
  },
  {
    "text": "Its broad transparent waters here spread out their unruffled surface, there danced along the rapids, while canoes filled with Indians glided swiftly in every direction, raising before them the timorous waterfowl that had already flocked in from the north."
  },
  {
    "text": "Many portions of that country had not been visited before even by the Indians, who assured Mr. Gillies of this fact."
  },
  {
    "text": "The road which we followed from Old Town to Bangor was literally covered with Penobscot Indians returning from market."
  },
  {
    "text": "On the first day we went fifty miles, in a sledge drawn by one horse, to the nearest lake, where we stopped for the night, in the hut of an Indian named Lewis, of the Passamaquoddy tribe, who had abandoned the wandering life of his race, and turned his attention to farming and lumbering."
  },
  {
    "text": "In the afternoon an Indian had driven a female Moose-deer, and two young ones of the preceding year, within a quarter of a mile of our camp, when he was obliged to shoot the old one."
  },
  {
    "text": "In the morning we started off on the track of a Moose, which had been driven from its haunt, or yard, by the Indians the day before; and although the snow was in general five feet deep, and in some places much deeper, we travelled three miles before we came to the spot where the Moose had rested for the night."
  },
  {
    "text": "We had proceeded about a mile and a half farther, when he took a sudden turn, which threw us off his track, and when we again found it, we saw that an Indian had taken it up, and gone in pursuit of the harassed animal. In a short time we heard the report of a gun, and immediately running up, we saw the Moose, standing in a thicket, wounded, when we brought him down. The animal finding himself too closely pursued, had turned upon the Indian, who fired, and instantly ran into the bushes to conceal himself. It was three years old, and consequently not nearly grown, although already about six feet and a half in height."
  },
  {
    "text": "On the following day we again set out, and coming across the tracks of two young bucks, which had been started by the Indians, we pursued them, and in two or three miles, overtook them."
  },
  {
    "text": "In that wild and secluded part of the country, seldom visited but by the Indians, the common Deer were without number, and it was with great difficulty that we kept the dogs with us, as they were continually meeting with 'beats.'"
  },
  {
    "text": "As we bore our usual arms and hunting accoutrements, which were half Indian and half civilized, the individuals we met on shore manifested considerable suspicion, which our captain observing, he instantly made a signal, when the star-spangled banner glided to the mast-head, and saluted the flags of France and Britain in kindly greeting."
  },
  {
    "text": "Signs of cultivation were observed on the slopes of the hills, the trees seemed of goodly size, a river made its way between two ranges of steep rocks, and here and there a group of Micmac Indians were searching along the shores for lobsters, crabs, and eels, all of which we found abundant and delicious. A canoe laden with Reindeer meat came alongside, paddled by a pair of athletic Indians, who exchanged their cargo for some of our stores."
  },
  {
    "text": "A set of primitive wooden stools and benches was placed around, for the reception of the belles of the village, some of whom now dropped in, flourishing in all the rosy fatness produced by an invigorating northern climate, and in decoration vying with the noblest Indian queen of the West."
  },
  {
    "text": "At the period when these poor birds are unfit for flight, troops of Indians make their appearance in light bark canoes, paddled by their squaws and papooses."
  },
  {
    "text": "The Indians have ceased to shout, and the canoes advance side by side."
  },
  {
    "text": "Amidst the highest waves of the Bay of Fundy, these feats are performed by the Indians during the whole of the season when the porpoises resort thither."
  },
  {
    "text": "The Indian quickly removes to the hills of the interior, the cattle and game swim to the different strips of land that remain uncovered in the midst of the flood, or attempt to force their way through the waters until they perish from fatigue."
  },
  {
    "text": "Although every European traveller who has glided down the Mississippi, at the rate of ten miles an hour, has told his tale of the squatters, yet none has given any other account of them, than that they are 'a sallow, sickly looking sort of miserable beings,' living in swamps, and subsisting on pig-nuts, Indian-corn, and Bear's-flesh. It is obvious, however, that none but a person acquainted with their history, manners, and condition, can give any real information respecting them."
  },
  {
    "text": "Here and there a solitary encampment of native Indians might be seen, but its inmates were as likely to prove foes as friends, having from their birth been made keenly sensible of the encroachments of the white men upon their lands."
  },
  {
    "text": "Kentucky was formerly attached to Virginia, but in those days the Indians looked upon that portion of the western wilds as their own, and abandoned the district only when forced to do so, moving with disconsolate hearts farther into the recesses of the unexplored forests."
  },
  {
    "text": "To these troubles add the constantly impending danger of being murdered, while asleep in their encampments, by the prowling and ruthless Indians; while they had before them a distance of hundreds of miles to be traversed, before they could reach certain places of rendezvous called Stations."
  },
  {
    "text": "In anticipation all is pleasure; and these migrating bands feasted in joyous sociality, unapprehensive of any greater difficulties than those to be encountered in forcing their way through the pathless woods to the land of abundance; and although it took months to accomplish the journey, and a skirmish now and then took place between them and the Indians, who sometimes crept unperceived into their very camp, still did the Virginians cheerfully proceed towards the western horizon, until the various groups all reached the Ohio, when, struck with the beauty of that magnificent stream, they at once commenced the task of clearing land, for the purpose of establishing a permanent residence."
  },
  {
    "text": "They prepared arks pierced with port-holes, and glided on the gentle current, more annoyed, however, than those who marched by land by the attacks of the Indians who watched their motions."
  },
  {
    "text": "Even the sides of the floating-mass were loaded with the wheels of the different vehicles, which themselves lay on the roof. Have they told you that these boats contained the little all of each family of venturous emigrants, who, fearful of being discovered by the Indians under night moved in darkness, groping their way from one part to another of these floating habitations, denying themselves the comfort of fire or light, lest the foe that watched them from the shore should rush upon them and destroy them?"
  },
  {
    "text": "During early spring our hunter would imitate the bleating of the doe, and thus frequently obtain both her and the fawn, or, like some tribes of Indians, he would prepare a Deer's head, placed on a stick, and creeping with it amongst the tall grass of the prairies, would decoy Deer in reach of his rifle."
  },
  {
    "text": "I was desired to raise and hold the platform on its central balance, whilst he, with all the dexterity of an Indian, threw a noose over the neck of one of the Wolves."
  },
  {
    "text": "At times I thought of the campaigns of my old friend, Daniel Boone, his strange adventures in these very woods, and the extraordinary walk which he performed to save his fellow creatures at Fort Massacre from the scalping knives of the irritated Indians."
  }
];

export default TEXTS;